import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import * as Chart from 'chart.js';
import 'chartjs-plugin-datalabels';
import * as Leaflet from 'leaflet';
import * as _ from 'lodash';
import { PortalService } from 'src/services/portal.service';
import * as Buffer from 'buffer';
import { Platform } from '@ionic/angular';
import * as moment from 'moment';

@Component({
  selector: 'painel-geral-component',
  templateUrl: 'painel-geral-component.html',
  styleUrls: ['painel-geral-component.scss'],
})
export class PainelGeralComponent implements OnInit, AfterViewInit {

  @ViewChild('elSelect', { static: false }) elSelect: ElementRef;
  @ViewChild('elListaItens', { static: false }) elListaItens: ElementRef;
  @ViewChild('elTitleCasos', { static: false }) elTitleCasos: ElementRef;
  @ViewChild('elTitleObitos', { static: false }) elTitleObitos: ElementRef;

  @Output() onScrollToPoint = new EventEmitter();
  @Output() onAlterTab = new EventEmitter();

  casosConfirmados = {
    total: null,
    homens: '55%',
    mulheres: '45%',
    titulo: 'Casos',
    novos: null,
    incidencia: null,
    recuperados: null,
    acompanhamento: null,
    percent: null
  };

  obitos = {
    total: null,
    homens: '55%',
    mulheres: '45%',
    titulo: 'Óbitos',
    novos: null,
    letalidade: null,
    mortalidade: null,
    percent: null
  };

  letalidade = {
    total: null,
    titulo: 'Letalidade'
  };

  versao = 'v1.0';
  dtAtualizacao: any;
  anoAtualizacao: any;
  mapLoading = true;

  geral: any = {};
  listRegiao: any[] = [];
  listRegiaoSaude: any[] = [];
  listDias: any[] = [];
  listSemana: any[] = [];
  listSemanaDia: any[] = [];
  listAcumulo: any = {
    labelsDias: []
  };
  listCidades: any[] = [];
  listCidadesRegiao: any[] = [];
  listMunicipios: any[] = [];
  listSintese: any = [];
  listCasos: any = {
    semana: []
  };

  datasetsAcumulo: any;
  datasetsAcumuloDias: any;
  datasetsAcumuloUF: any;
  datasetsAcumuloUFDias: any;
  datasetsObitosAcumulo: any;
  datasetsObitosAcumuloDias: any;
  datasetsAcumuloUFObito: any;
  datasetsAcumuloUFDiasObito: any;

  datasetsSemanaDia: any;
  datasetsSemana: any;
  datasetsObitosSemana: any;
  datasetsObitosSemanaDia: any;
  datasetsDias: any;
  updateAt: any;
  maxWidthList = false;
  list = false;
  loadState = true;
  loadStateI = true;
  loadStateII = true;
  loadStateIII = true;
  selected = 'Brasil';
  selectedI = 'Brasil';
  selectedII = 'Brasil';
  selectedIII = 'Brasil';

  arrColor = {
    AC: '#50c8ff',
    AL: '#9725bf',
    AP: '#C9D200',
    AM: '#f66416',
    BA: '#EE328C',
    CE: '#5d1e99',
    DF: '#f5b52e',
    ES: '#7730AF',
    GO: '#7DB61C',
    MA: '#6688ff',
    MT: '#eb445a',
    MS: '#36abe0',
    MG: '#5D5ADC',
    PA: '#0eff01',
    PB: '#FAB822',
    PR: '#0088FF',
    PE: '#1FBB87',
    PI: '#00AE9D',
    RJ: '#AF309B',
    RN: '#03480a',
    RS: '#00AE9D',
    RO: '#7ea30a',
    RR: '#8a41c6',
    SC: '#cb41f1',
    SP: '#EE328C',
    SE: '#f66416',
    TO: '#02a7b9'
  };

  constructor(private portal: PortalService,
    private inAppBrowser: InAppBrowser,
    public platform: Platform,
    private cd: ChangeDetectorRef) {
  }

  async ngOnInit() {
    console.log('ngOnInit -> PainelGeralComponent');
    this.loadDatas();
    this.listMunicipios = await this.portal.getMunicipio();
  }

  ngAfterViewInit() {
    const thi$ = this;
    setTimeout(() => {
      if (thi$.elListaItens && (thi$.elListaItens.nativeElement.clientWidth <= 790)) {
        this.maxWidthList = true;
      }
    }, 400);
  }

  async loadDatas() {
    this.loadGeral();
    this.loadRegiao();
    this.loadRegiaoSaude();
    this.loadSemana();
    this.loadAcumulo();
  }

  async loadGeral() {
    const geral = await this.portal.getCDN('PortalGeral');
    const full = await this.portal.getGeral();
    this.geral = geral[0];
    this.casosConfirmados = full.confirmados;
    this.obitos = full.obitos;
    this.versao = this.geral.versao;
    this.updateAt = this.geral.dt_atualizacao.replace('/2020', '');
    this.loadlist();
    this.dtAtualizacao = full.dt_updated;
    this.anoAtualizacao = full.dt_updated.split("-")[0]
    this.listCidades = await this.portal.getEstado();
    this.listCidadesRegiao = await this.portal.getEstadoRegiao();
    this.mapLoading = false;
  }

  async loadlist() {
    let listSintese = await this.portal.getSinteseSep();
    let result = [];
    if (listSintese && listSintese.length > 0) {
      result = [listSintese[0]]
      for (const element of listSintese[1]) {
        if (element._id != 'Brasil') {
          if (element._id == 'Centro-Oeste') {
            element.listaMunicipios = await this.portal.getSinteseSepParam('CentroOeste');
          }
          if (element._id == 'Sul') {
            element.listaMunicipios = await this.portal.getSinteseSepParam('Sul');
          }
          if (element._id == 'Norte') {
            element.listaMunicipios = await this.portal.getSinteseSepParam('Norte');
          }
          if (element._id == 'Nordeste') {
            element.listaMunicipios = await this.portal.getSinteseSepParam('Nordeste');
          }
          if (element._id == 'Sudeste') {
            element.listaMunicipios = await this.portal.getSinteseSepParam('Sudeste');
          }
          result.push(element)
        }
      };
    }
    console.log(result)
    this.listSintese = result;
    this.list = true;
  }

  async loadRegiaoSaude() {
    this.listRegiaoSaude = await this.portal.getRegiaoSaude();
    // this.list = true;
  }

  onSelectCard(tipo) {
    if (tipo && tipo === 'Casos') {
      this.onScrollToPoint.emit({ point: this.elTitleCasos.nativeElement.offsetTop });
    } else if (tipo && tipo === 'Óbitos') {
      this.onScrollToPoint.emit({ point: this.elTitleObitos.nativeElement.offsetTop });
    } else if (tipo && tipo === 'Sobre') {
      if (this.platform.is('cordova')) {
        this.inAppBrowser.create('https://infoms.saude.gov.br/extensions/covid-19_html/covid-19_html.html', '_system', 'location=no');
      } else {
        this.inAppBrowser.create('https://infoms.saude.gov.br/extensions/covid-19_html/covid-19_html.html', '_blank');
      }
    }
  }


  async loadAcumulo() {
    this.listAcumulo = await this.portal.getRegiao();
    const value = this.listAcumulo.Sudeste;
    const complement = this.listAcumulo.Sul;
    this.listAcumulo.Brasil = Object.assign({}, this.getTopElements(10));
    this.loadGrap();
  }

  getTopElements(limit) {
    const newRooms = {};
    let i = 0;
    const keys = Object.keys(this.listAcumulo.geral);

    for (const key of keys) {
      if (i < limit) {
        newRooms[key] = this.listAcumulo.geral[key];
        i++;
      } else {
        return newRooms;
      }
    }
    return newRooms;
  }

  loadGrap() {
    const self = this;
    this.datasetsAcumuloUFDias = {
      labels: this.listAcumulo.labelsDias,
      datasets: _.map(this.listAcumulo[this.selected], (x, key) => {
        const color = self.arrColor[key];
        return {
          label: key,
          pointRadius: 1,
          borderColor: color,
          backgroundColor: 'rgba(250, 184, 34, 0)',
          pointBorderColor: 'rgba(29, 165, 132, 0)',
          pointBackgroundColor: color,
          data: _.map(x.dias, 'casosAcumulado'),
          datalabels: {
            display: false,
          },
        };
      })
    };
    this.datasetsAcumuloUF = {
      labels: this.listAcumulo.labelsSemanas,
      datasets: _.map(this.listAcumulo[this.selectedI], (x, key) => {
        const color = self.arrColor[key];
        return {
          label: key,
          pointRadius: 1,
          borderColor: color,
          backgroundColor: 'rgba(250, 184, 34, 0)',
          pointBorderColor: 'rgba(29, 165, 132, 0)',
          pointBackgroundColor: color,
          data: _.map(x.semana, 'casosAcumulado'),
          datalabels: {
            display: false,
          },
        };
      })
    };

    this.datasetsAcumuloUFDiasObito = {
      labels: this.listAcumulo.labelsDias,
      datasets: _.map(this.listAcumulo[this.selectedII], (x, key) => {
        const color = self.arrColor[key];
        return {
          label: key,
          pointRadius: 1,
          borderColor: color,
          backgroundColor: 'rgba(250, 184, 34, 0)',
          pointBorderColor: 'rgba(29, 165, 132, 0)',
          pointBackgroundColor: color,
          data: _.map(x.dias, 'obitosAcumulado'),
          datalabels: {
            display: false,
          },
        };
      })
    };
    this.datasetsAcumuloUFObito = {
      labels: this.listAcumulo.labelsSemanas,
      datasets: _.map(this.listAcumulo[this.selectedIII], (x, key) => {
        const color = self.arrColor[key];
        return {
          label: key,
          pointRadius: 1,
          borderColor: color,
          backgroundColor: 'rgba(250, 184, 34, 0)',
          pointBorderColor: 'rgba(29, 165, 132, 0)',
          pointBackgroundColor: color,
          data: _.map(x.semana, 'obitosAcumulado'),
          datalabels: {
            display: false,
          },
        };
      })
    };
  }

  async loadRegiao() {
    this.listRegiao = await this.portal.getCDN('PortalRegiao');
  }

  async filtroState(evnt) {
    this.loadState = false;
    this.selected = evnt;
    this.loadGrap();
    const self = this;
    setTimeout(() => {
      self.loadState = true;
    }, 200);
  }

  async filtroStateI(evnt) {
    this.loadStateI = false;
    this.selectedI = evnt;
    this.loadGrap();
    const self = this;
    setTimeout(() => {
      self.loadStateI = true;
    }, 200);
  }

  async filtroStateII(evnt) {
    this.loadStateII = false;
    this.selectedII = evnt;
    this.loadGrap();
    const self = this;
    setTimeout(() => {
      self.loadStateII = true;
    }, 200);
  }

  async filtroStateIII(evnt) {
    this.loadStateIII = false;
    this.selectedIII = evnt;
    this.loadGrap();
    const self = this;
    setTimeout(() => {
      self.loadStateIII = true;
    }, 200);
  }

  async loadSemana() {
    this.listCasos = await this.portal.getCasos();
    this.listCasos.dias.shift();
    this.listCasos.dias.shift();
    this.datasetsSemanaDia = {
      labels: _.map(this.listCasos.dias, x => x._id.toString()),
      datasets: [
        {
          label: 'Casos',
          datalabels: {
            display: false,
          },
          backgroundColor: '#1DA584',
          data: _.map(this.listCasos.dias, 'casosNovos'),
        }
      ],
    };

    console.log('==========', _.map(this.listCasos.semana, x => x._id.toString()))


    const anoAtual = moment().year();

    const anosCasosNovos = {};
    anosCasosNovos[anoAtual - 1] = [];
    anosCasosNovos[anoAtual] = [];
    const anosCasosAcumulado = {};
    anosCasosAcumulado[anoAtual - 1] = [];
    anosCasosAcumulado[anoAtual] = [];
    const anosObitosNovos = {};
    anosObitosNovos[anoAtual - 1] = [];
    anosObitosNovos[anoAtual] = [];
    const anosObitosAcumulado = {};
    anosObitosAcumulado[anoAtual - 1] = [];
    anosObitosAcumulado[anoAtual] = [];


    let anoAux = anoAtual;
    let ano = anoAtual - 1;
    this.listCasos.semana.forEach(item => {
      if (item._id == 1) {
        ano = anoAtual;
        anoAux = anoAtual - 1;
      }
      anosCasosNovos[ano].push(item.casosNovos);
      anosCasosNovos[anoAux].push(NaN);

      anosCasosAcumulado[ano].push(item.casosAcumulado);
      anosCasosAcumulado[anoAux].push(NaN);

      anosObitosNovos[ano].push(item.obitosNovos);
      anosObitosNovos[anoAux].push(NaN);

      anosObitosAcumulado[ano].push(item.obitosAcumulado);
      anosObitosAcumulado[anoAux].push(NaN);

    });

    this.datasetsSemana = {
      labels: _.map(this.listCasos.semana, x => x._id.toString()),
      datasets: [
        {
          label: anoAtual - 1,
          backgroundColor: '#1DA584',
          datalabels: {
            display: false,
          },
          data: anosCasosNovos[anoAtual - 1],
        },
        {
          label: anoAtual,
          backgroundColor: '#AF309B',
          datalabels: {
            display: false,
          },
          data: anosCasosNovos[anoAtual],
        }
      ],
    };

    this.datasetsObitosSemana = {
      labels: _.map(this.listCasos.semana, x => x._id.toString()),
      datasets: [
        {
          label: anoAtual - 1,
          datalabels: {
            display: false,
          },
          backgroundColor: '#9A36BB',
          data: anosObitosNovos[anoAtual - 1],
        },
        {
          label: anoAtual,
          datalabels: {
            display: false,
          },
          backgroundColor: '#1DA584',
          data: anosObitosNovos[anoAtual],
        }
      ],
    };

    this.datasetsAcumulo = {
      labels: _.map(this.listCasos.semana, x => x._id.toString()),
      datasets: [
        {
          label: anoAtual - 1,
          borderColor: '#1DA584',
          backgroundColor: 'rgba(29, 165, 132, .15)',
          pointBorderColor: 'rgba(29, 165, 132, 0)',
          pointBackgroundColor: '#1DA584',
          data: anosCasosAcumulado[anoAtual - 1],
          datalabels: {
            display: false,
          },
        },
        {
          label: anoAtual,
          borderColor: '#AF309B',
          backgroundColor: 'rgba(175,48,155, .15)',
          pointBorderColor: 'rgba(175,48,155, 0)',
          pointBackgroundColor: '#AF309B',
          data: anosCasosAcumulado[anoAtual],
          datalabels: {
            display: false,
          },
        }
      ]
    };

    this.datasetsObitosAcumulo = {
      labels: _.map(this.listCasos.semana, x => x._id.toString()),
      datasets: [
        {
          label: anoAtual - 1,
          borderColor: '#9A36BB',
          backgroundColor: 'rgba(154, 54, 187, .15)',
          pointBorderColor: 'rgba(154, 54, 187, 0)',
          pointBackgroundColor: '#9A36BB',
          data: anosObitosAcumulado[anoAtual - 1],
          datalabels: {
            display: false,
          },
        },
        {
          label: anoAtual,
          borderColor: '#1DA584',
          backgroundColor: 'rgba(29, 165, 132, .15)',
          pointBorderColor: 'rgba(29, 165, 132, 0)',
          pointBackgroundColor: '#1DA584',
          data: anosObitosAcumulado[anoAtual],
          datalabels: {
            display: false,
          },
        }
      ]
    };

    this.datasetsObitosAcumuloDias = {
      labels: _.map(this.listCasos.dias, x => x._id.toString()),
      datasets: [
        {
          label: 'Óbitos',
          borderColor: '#9A36BB',
          backgroundColor: 'rgba(154, 54, 187, .15)',
          pointBorderColor: 'rgba(154, 54, 187, 0)',
          pointBackgroundColor: '#9A36BB',
          data: _.map(this.listCasos.dias, 'obitosAcumulado'),
          datalabels: {
            display: false,
          },
        },
      ]
    };

  }
}
